<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/AzureBillingPeriods">Azure Billing Periods</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Billing Periods</div>
            <div class="card-body">

                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="billingPeriods"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                        <div class="btn-group btn-group-sm">
                            <router-link :to="{name:'AzureBillingPeriodSubscriptions',params:{billingPeriodId:row.item.id}}"
                                         class="btn btn-sm btn-primary d-print-none"
                                         data-toggle="tooltip"
                                         title="View Billing Period Details">
                              Details
                            </router-link>
                            <button @click="downloadInvoice(row.item.id)" class="btn btn-secondary btn-sm d-print-none"><i
                                    class="fa fa-file-invoice-dollar"></i> Invoice
                            </button>
                        </div>
                    </template>

                    <template v-slot:cell(startDate)="row">
                        <span>{{row.item.startDate | date}}</span>
                    </template>

                    <template v-slot:cell(endDate)="row">
                        <span>{{row.item.endDate | date}}</span>
                    </template>

                    <template v-slot:cell(totalUsage)="row">
                        <span>{{row.item.totalUsage | currency}}</span>
                    </template>

                    <template v-slot:cell(totalOverage)="row">
                        <span>{{row.item.totalOverage | currency}}</span>
                    </template>

                    <template v-slot:cell(totalAdjustments)="row">
                        <span>{{row.item.totalAdjustments | currency}}</span>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalBillingPeriods"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>

            </div>
        </div>

    </div>
</template>

<script>
    import AzureBillingService from "@/services/AzureBillingService";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {currency} from "@/filters/Currency";
    import {date} from "@/filters/Date"

    export default {
        components: {
            AppTablePagination,
        },
        filters: {
            currency,
            date
        },
        data() {
            return {
                billingPeriods: [],
                totalBillingPeriods: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:200px'
                    },
                    {
                        key: 'startDate',
                        label: 'Start Date',
                    },
                    {
                        key: 'endDate',
                        label: 'End Date',
                    },
                    {
                        key: 'totalUsage',
                        label: 'Total Usage',
                        thClass: 'text-right',
                        tdClass: 'text-right',
                    },
                    {
                        key: 'totalOverage',
                        label: 'Total Overage',
                        thClass: 'text-right',
                        tdClass: 'text-right',
                    }, {
                        key: 'totalAdjustments',
                        label: 'Total Adjustments',
                        thClass: 'text-right',
                        tdClass: 'text-right',
                    },

                ]
            }
        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                AzureBillingService.getBillingPeriodsList(vm.filterOptions)
                    .then(response => {
                        vm.billingPeriods = response.data;
                        vm.totalBillingPeriods = response.totalCount;
                    })
                    .catch(() => {
                        vm.redirectToError()
                    }).finally(() => {
                    vm.isLoading = false;
                })
            },

            /**
             * @description Downloads the invoice for the given billing period id
             */
            downloadInvoice: function (id) {
                const vm = this;

                AzureBillingService.downloadInvoice(id)
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    });
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
